<template>
  <div class="pinwallList__list">
    <ul>
      <li
        v-for="item in items"
        :key="item.id"
        @click="open(item)"
        :style="getItemHeight(item)"
      >
        <div class="crop" :title="`${$t('open')} Pinwall`">
          <img
            v-if="item.image"
            :src="getImageSrc(item.image)"
            @error="
              post.image.type === 'local' ? replaceByDefault($event, post) : ''
            "
          />
          <i
            v-if="item.options.private"
            class="material-icons-round lock-icon"
            :style="setStyle('icon', item)"
            >lock</i
          >
        </div>
        <div class="details">
          <UserImage
            :src="item.userImg"
            :username="item.username"
            :style="setStyle('img', item)"
            :view="'list'"
          />
          <div class="meta-with-icon" :style="setStyle('meta', item)">
            <div class="name">
              <p>{{ item.name }}</p>
            </div>
            <div v-if="item.desc && item.desc !== ''" class="desc">
              <p>{{ item.desc }}</p>
            </div>
            <div class="info">
              <span
                class="info-icon"
                @click.stop.prevent="$emit('selectSpace', item.space)"
                :title="
                  `${$t('open')} ${getSpaceText(item)} ${$t('space.title')}`
                "
                :style="`background-color: ${getColor(item.space)}`"
                >{{
                  item.spaceName
                    ? item.spaceName.firstChar()
                    : item.space.firstChar()
                }}</span
              >
              <span>
                {{
                  item.postsCount > 1
                    ? `${getSpaceText(item)} • ${
                        item.postsCount
                      } Posts • ${getTime(item)}`
                    : `${getSpaceText(item)} • ${
                        item.postsCount
                      } Post • ${getTime(item)}`
                }}
              </span>
            </div>
          </div>
          <div>
            <b-button
              @click.stop.prevent="$emit('like', item)"
              class="like-button"
              icon-left="thumb-up"
              type="is-text"
              >{{ item.likes }}</b-button
            >
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { getHSLColor, getTimeAgoString } from "../../utils/helpers";
import UserImage from "../core/UserImage.vue";

export default {
  name: "list",
  props: {
    items: {
      type: Array
    },
    selectedSpace: {
      type: Object
    }
  },
  components: {
    UserImage
  },
  computed: {
    ...mapGetters(["currentScrollPosition"])
  },
  data: () => {
    return {
      sort: {
        newest: true,
        likes: false
      },
      mobileWidth: process.env.VUE_APP_MOBILE_WIDTH
    };
  },
  methods: {
    ...mapMutations(["setCurrentScrollPosition"]),
    open(item) {
      this.setCurrentScrollPosition(window.scrollY);
      let url = `${item.space}/${item.pinwallId}`;
      this.$router.push(
        item.tenant !== process.env.VUE_APP_DEFAULT_TENANT
          ? `${item.tenant}/${url}`
          : url
      );
    },
    getColor(spaceId) {
      return getHSLColor(spaceId);
    },
    getImageSrc(image) {
      if (image.type && image.type === "local") {
        return image.source.replace(".jpg", ".webp").replace(".png", ".webp");
      }
      return image.source;
    },
    getSpaceText(item) {
      if (item.spaceName === "all" || item.space === "all") {
        return this.$t("space.all");
      }

      if (item.spaceName) {
        return item.spaceName.startText(0);
      }

      if (item.space) {
        return item.space.startText(0);
      }

      return "";
    },
    replaceByDefault(e, item) {
      let fileExtensions =
        item.image.mimeType && item.image.mimeType.includes("png")
          ? ".png"
          : ".jpg";

      e.target.src = item.image.source.replace(".webp", fileExtensions);
    },
    getTime(item) {
      return getTimeAgoString(item.createDate, this.$t("time"));
    },
    getItemHeight(item) {
      if (item.desc === "" && this.windowWidth <= 580) {
        return "height: 286px;";
      }
      return "";
    },
    setStyle(element, item) {
      let style = "";

      if (this.windowWidth <= 536 && element === "meta") {
        var width = Math.round(
          this.windowWidth * (0.04672 + 50 / this.windowWidth)
        );
        if (item.userImg || item.options.private) {
          style += `width: ${width}% !important;`;
        } else {
          style += `width: calc(${width}% + 60px) !important;`;
        }
      }

      return style;
    }
  },
  mounted() {
    window.scrollTo(0, this.currentScrollPosition);
  }
};
</script>
